<template>
  <div class="merchant-grid">
    <a
      v-for="merchant in customerLimitStore.merchants"
      class="merchant-grid-item"
      :href="merchant.website ? merchant.website : null"
      target="_blank"
    >
      <img
        class="merchant-grid-logo"
        :src="merchant.logoUrl"
      >
      <div class="merchant-grid-text">
        <span class="merchant-grid-merchant-name">
          {{ merchant.description }}
        </span>
        <span class="merchant-grid-offer-limits">
          {{ 
            $t("bnpl:customer_limit.merchants.card.text", {
              min: $n(merchant.minAmount || 0, "currency"),
              max: $n(merchant.maxAmount || 0, "currency"),
            })
          }}
        </span>
      </div>
    </a>
  </div>
</template>

<script setup>
import { useCountryStore } from '~~/stores/country';
import { useCustomerLimitStore } from '~~/stores/customerLimit';

const customerLimitStore = useCustomerLimitStore();
const countryStore = useCountryStore();

onMounted(async () => {
  await customerLimitStore.getMerchants(countryStore.countryId);
  await customerLimitStore.fetchMerchantLogos();
});
</script>

<style>

</style>